import { render, staticRenderFns } from "./DeleteKeycloakButton.vue?vue&type=template&id=bc7cd796&scoped=true"
import script from "./DeleteKeycloakButton.vue?vue&type=script&lang=js"
export * from "./DeleteKeycloakButton.vue?vue&type=script&lang=js"
import style0 from "./DeleteKeycloakButton.vue?vue&type=style&index=0&id=bc7cd796&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7cd796",
  null
  
)

export default component.exports